// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1X0ak","tabsBox":"styles_tabsBox__2dfkS","createButton":"styles_createButton__3X4FM"};